<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn><h3 class="text-center">Cambiar Datos de Acceso al Sistema</h3>
    <p class="text-center text-primary" style="margin-bottom:0"> <small class="center-block"> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios </small> </p>

    <Datos />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import Datos from '@/components/AClaveUsuarios.vue'
export default {
  data(){
    return{

    }
  },
  components:{Datos},
  mounted(){
    // window.console.log( "fhfghfgh   ",this.datos ) 
  }
}
</script>